var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-info-item"},[_c('InfoItemTitle',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"ui-info-item_data"},[_vm._v(_vm._s(_vm.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }